import pluralize from "@/lib/pluralize";

export type SnackbarCopy = {
  headline: string;
  subtitle?: string;
};

export function finalizePartialFailureSnackbarFeedback(successfulCount: number): SnackbarCopy {
  const personLabel = pluralize(successfulCount, "person", undefined, "people");
  return {
    headline: "Some applications could not be elected",
    subtitle: `Finalized elections for ${successfulCount} ${personLabel}.`
  };
}

export function finalizeAllFailedMessage(): string {
  return "None of the selected applications could be elected.";
}

export function finalizeListRefreshSnackbarFeedback(successfulCount: number): SnackbarCopy {
  if (successfulCount > 0) {
    return { headline: "List not refreshed", subtitle: "Elections were finalized." };
  }

  return { headline: "List not refreshed" };
}

export function electionDateListRefreshSnackbarFeedback(): SnackbarCopy {
  return { headline: "List not refreshed", subtitle: "Election dates were saved." };
}
